const testimonials = [
  {
    quote: "Alice Gosfield and her team provided exceptional guidance navigating a complex Medicare compliance audit. Their expertise and responsiveness were invaluable — we resolved the matter far better than anticipated.",
    name: "Dr. Michael R.",
    role: "Physician Practice Owner",
    location: "Pennsylvania",
    rating: 5,
  },
  {
    quote: "The firm's depth of knowledge in health care regulation is unmatched. They helped us restructure our managed care contracts and implement a compliance program that has protected our organization for years.",
    name: "Karen T.",
    role: "Chief Compliance Officer",
    location: "Regional Health System",
    rating: 5,
  },
  {
    quote: "We retained Gosfield &amp; Associates after receiving a government inquiry involving Stark Law. Their strategic approach and authoritative knowledge led to a successful resolution with minimal disruption.",
    name: "James F.",
    role: "General Counsel",
    location: "Medical Group Network",
    rating: 5,
  },
  {
    quote: "As a hospital system across multiple states, we needed counsel who truly understands federal and state health law. This firm delivers consistently excellent results and is always our first call.",
    name: "Patricia M.",
    role: "VP Legal Affairs",
    location: "Multi-State Health System",
    rating: 5,
  },
];

export default function SectionTestimonials() {
  return (
    <section className="bg-[#0A1628] py-24 relative overflow-hidden">
      {/* Decorative quote mark */}
      <div className="absolute top-12 right-16 opacity-5">
        <i className="ri-double-quotes-r text-[#C9A961]" style={{ fontSize: "200px" }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-14">
          <div>
            <span className="block text-[11px] tracking-[0.25em] text-[#C9A961] uppercase font-inter font-medium mb-3">
              Client Stories
            </span>
            <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-white">
              What Our Clients Say
            </h2>
          </div>
          <div className="mt-4 lg:mt-0 flex items-center gap-2">
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-[#C9A961] text-sm" />
              ))}
            </div>
            <span className="text-slate-400 text-sm font-inter">5.0 avg rating</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="relative p-8 rounded-xl bg-white/5 border border-white/10 hover:border-[#C9A961]/30 hover:bg-white/8 transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#C9A961] text-sm" />
                ))}
              </div>

              {/* Large quote mark */}
              <div className="absolute top-6 right-6 opacity-10">
                <i className="ri-double-quotes-r text-[#C9A961]" style={{ fontSize: "40px" }} />
              </div>

              <p className="text-slate-200 font-playfair italic text-base leading-relaxed mb-6 pr-4">
                &ldquo;{t.quote}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div className="w-10 h-10 rounded-full bg-[#C9A961]/20 border border-[#C9A961]/30 flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-[#C9A961] text-base" />
                </div>
                <div>
                  <div className="text-white text-sm font-inter font-semibold">{t.name}</div>
                  <div className="text-slate-400 text-xs font-inter">
                    {t.role} &mdash; {t.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
